import React from "react";

interface JobsHistoryButtonProps {
	onClick: () => void;
}

const JobsHistoryButton: React.FC<JobsHistoryButtonProps> = ({ onClick }) => {
	return (
		<button
			className="inline-flex items-center gap-2 bg-gray-200 text-gray-700 px-4 py-2 rounded hover:bg-gray-300 transition-colors"
			onClick={onClick}
		>
			<svg
				className="w-5 h-5"
				fill="none"
				stroke="currentColor"
				viewBox="0 0 24 24"
			>
				<path
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth={2}
					d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
				/>
			</svg>
			View Jobs History
		</button>
	);
};

export default JobsHistoryButton;
